module.exports = __webpack_public_path__ + "static/img/3-EN-old.cc23b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/3-EN-old.png
// module id = MLwB
// module chunks = 1